import { render } from "./FormatBold.vue?vue&type=template&id=3ebe1cd0"
import script from "./FormatBold.vue?vue&type=script&lang=js"
export * from "./FormatBold.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/FormatBold.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3ebe1cd0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3ebe1cd0', __exports__)) {
    api.reload('3ebe1cd0', __exports__)
  }
  
  module.hot.accept("./FormatBold.vue?vue&type=template&id=3ebe1cd0", () => {
    api.rerender('3ebe1cd0', render)
  })

}


export default __exports__